export default __webpack_public_path__ + "static/media/addShortcut-1-zh.0f12897e.JPG";